import type { ReactElement } from 'react';

export const Dice8 = (): ReactElement => {
    return (
        <>
            <g transform="scale(40) translate(0, -24)">
                <path d="M.5,10.576,9.846.724A3.045,3.045,0,0,1,11,.007V13.662ZM13,13.662l10.5-3.088L14.155.725,14.109.676A2.9,2.9,0,0,0,13,0Zm0,2.085V24a3.113,3.113,0,0,0,1.155-.731L24,12.513Zm-2,0L0,12.513l9.891,10.8A2.953,2.953,0,0,0,11,24Z" />
            </g>
            <title>dice 8</title>
        </>
    );
};
